import React, { Component } from 'react';

class HowItWorks extends Component {
  ref = React.createRef();

  componentDidMount() {
    const { observer = {} } = this.props;
    observer.observe(this.ref.current);
  }

  render() {
    const {
      images: { desktopBanner = '', mobileBanners = [], desktopAlt = '' } = {},
      content: { headerText = '' } = {}
    } = this.props.data;
    return (
      <div className="storePickup" id="howitworks" ref={this.ref}>
        <div className="heading1">{headerText}</div>
        <div className="how-itworks-path">
          <img src={desktopBanner} alt={desktopAlt} />
        </div>
        <div className="how-itworks-path-mobile">
          {mobileBanners.map((bannerObj, i) => {
            return (
              <div key={i} className="step">
                <img className="logos" src={bannerObj.banner} alt={bannerObj?.alt || ''} />
                <label dangerouslySetInnerHTML={{ __html: bannerObj.text }} />
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default HowItWorks;
